import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import withConfiguration from 'components/providers/configuration/with-configuration'
import backgroundStyles from './page-background-style'

const PageBackground = props => {
  const styles = backgroundStyles()
  const classes = classNames(
    styles.backgroundLayer,
    {
      [styles.mobileBackground]: props.mobileBackgroundEnabled,
    }
  )

  return (
    <span className={classes} />
  )
}

PageBackground.propTypes = {
  portalConfiguration: PropTypes.object,
  mobileBackgroundEnabled: PropTypes.bool,
}

PageBackground.defaultProps = {
  mobileBackgroundEnabled: false,
}

export default withConfiguration(PageBackground)
